import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import styles from "./LegendBox.module.styl";

export default function LegendBox({ size, color, text, textSize, textColor, dataTestName }) {
    const blockClasses = cx(styles.block, styles["size_" + size], styles["color_" + color]);

    const textClasses = cx(styles["textSize_" + textSize], styles["textColor_" + textColor]);

    return (
        <div className={styles.legend} data-test-name={dataTestName}>
            <div className={blockClasses} />
            <div className={textClasses}>{text}</div>
        </div>
    );
}

LegendBox.propTypes = {
    size: PropTypes.oneOf(["big", "small", "normal"]),
    color: PropTypes.oneOf(["green", "red", "orange", "gray"]),
    text: PropTypes.string,
    textSize: PropTypes.oneOf(["big", "small", "normal"]),
    textColor: PropTypes.oneOf(["red", "orange", "green", "gray", "none"]),
    dataTestName: PropTypes.string,
};

LegendBox.defaultProps = {
    size: "small",
    color: "gray",
    textSize: "normal",
    textColor: "none",
};
